import { authHeader } from '../_helpers';
//import axios from 'axios';

export const userService = {
    login,
    logout,
    getAll,
    getUser,
    Check_Null_Empty,
    ValidateEmail,
    validatePhoneNumber,
    validateCurrency,
    ValidateEmailPlus,
    ValidateSpace,
    AddDollar,
    PaymentRails,
    validateNumber,
    loginrxh,
    GetWh_Analytic,
    GetWh_Termination,
    Accept_Comp_Popup,
    Check_LoggedIn_Status,
    Get_User_Type,
    GetAdvanceSetting,
    UpdatedAdvanceSetting,
    BrokerSignatureSetting,
    BindAnalyticsFilteredTag,
    Export_reps_bytransaction,
    BonusProgram,
    Bind_Tier_List,
    Wh_GlicAPI,
    Wh_Bonus_Setting,
    checkNumericValue,
    Admin_Any_Search,
    TierProperties,
    UpdateFinanceUser,
    GetDashboardList,
    AddWhDashUser,
    SaveNotification,
    GetNotification,
    GetUserNotification,
    NotificationAcknowledge,
    SearchEmailCampaignType,
    ProcessUserCampaign,
    NotificationClosing,
    CompnayOverViewSearch,
    WhPrescribeInfo,
    GetWhiteListedIP,
    ProcessWhiteListIP,
    ResetWhiteListIP,
    fetchPharmacyChainList,
    fetchUserPharmacyChainList,
    updatePharmacyChainList,
    wh_ChainCommission,
    add_update_PharmacyChainList_gs,
    generatebearerToken,
    regeneratebearerToken,
    listTokens
};
export const apiCall = async (url, options = {}) => {
    const headers = {
        ...options.headers,
        'X-UI-Request': 'true', // Add the header dynamically
    };

    const response = await fetch(url, { ...options, headers });
    return response.json();
};
function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ username, password })
        //body: "username="+encodeURI(username) +"&password="+encodeURI(password)
    };

    //return fetch(`api/user/authenticate`, requestOptions)
    //    .then(handleResponse)
    //    .then(user => {
    //        // login successful if there's a user in the response
    //        if (user) {
    //            debugger;
    //            var userObj = {};
    //            // store user details and basic auth credentials in local storage 
    //            // to keep user logged in between page refreshes
    //            userObj.userrole = user[0].userRole;
    //            userObj.id = user[0].id;
    //            userObj.email = user[0].email;
    //            userObj.username = user[0].userName;
    //            userObj.wholesaler = user[0].wholesaler;
    //            userObj.authdata = window.btoa(username + ':' + user[0].userPwd);
    //            //console.log(userObj)

    //            localStorage.setItem('user', JSON.stringify(userObj));
    //        }

    //        return user;
    //    });

    return fetch(`api/user/Authenticate_D`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
                if (user) {
                    var userObj = {};
                    // store user details and basic auth credentials in local storage 
                    // to keep user logged in between page refreshes
                    userObj.userrole = user[0].role;
                    userObj.id = user[0].userId;
                    userObj.email = user[0].userEmail;
                    userObj.username = user[0].userName;
                    userObj.wholesaler = user[0].wholesaler;
                    userObj.wholesaler_Id = user[0].wholesaler_Id;
                    userObj.distributor_UserId = user[0].distributor_UserId;
                    userObj.authdata = window.btoa(username + ':' + user[0].logg_Set);
                    userObj.paramsname = user[0].paramsName;
                    userObj.dList = user[0].dList;
                    userObj.isfu = user[0].isFu;
                    userObj.isForAnalytic = user[0].isForAnalytic;
                    userObj.iscompopup = user[0].isComPopup;
                    userObj.overrideCount = user[0].overrideCount;
                    userObj.r_rgh_i_e_b = window.btoa(user[0].isEnableBroker);
                    userObj.isBrokerTypeUser = user[0].isBrokerTypeUser;
                    userObj.isLegacyUser = user[0].isLegacyUser;
                    userObj.unique_ObjectId = user[0].unique_ObjectId;
                    userObj.isPrescribeData = user[0].isPrescribeData;
                    localStorage.setItem('x_resu_c_dat_presc', user[0].isPrescribeData);
                    localStorage.setItem('user', JSON.stringify(userObj));
                    localStorage.setItem('x_resu_t_p', user[0].isFu);
                    localStorage.setItem('x_resu_c_p_p', user[0].isComPopup);

                    //console.log('login done' + userobj.email);
                    //x();


                }
                else {
                    var userObj = {};
                    localStorage.setItem('user', JSON.stringify(userObj));
                }
            }
            catch (error) {
                var userObj = {};
                localStorage.setItem('user', JSON.stringify(userObj));
            }
            return user;
        });

    //return axios({
    //    method: 'post',
    //    url: 'api/user/authenticate',
    //    data: JSON.stringify({ username, password }),
    //    headers: {
    //        'Content-Type': 'application/json'
    //    }
    //})
    //    .catch(function (error) {
    //        console.log(error);
    //    }).then(handleResponse)
    //    .then(user => {
    //        var userObj;
    //        // login successful if there's a user in the response
    //        if (user.data.length > 0) {
    //            // store user details and basic auth credentials in local storage 
    //            // to keep user logged in between page refreshes
    //            userObj.id = user.data[0].id;
    //            userObj.username = user.data[0].userName;
    //            userObj.authdata = window.btoa(username + ':' + user.data[0].userPwd);

    //            localStorage.setItem('user', JSON.stringify(userObj));
    //        }

    //        return user.data;
    //    });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('Select_Sort_Processor');
    localStorage.removeItem('Prev_Filter_Status');
    localStorage.removeItem('Updated_Filter_Status');
    localStorage.removeItem('Prev_AdFilter_Status');
    localStorage.removeItem('Updated_AdFilter_Status');
    localStorage.removeItem('Select_Sort_Value');
    localStorage.removeItem('Filter_Last_Update_Time');
    localStorage.removeItem('Select_Sort_Name');
    localStorage.removeItem('User_End_Date');
    localStorage.removeItem('User_Start_Date');
    localStorage.removeItem('Prev_HD_Type');
    localStorage.removeItem('Updated_HD_Type');
    localStorage.clear();


    // window.location = window.location.origin;
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`api/user/Get`, requestOptions).then(handleResponse);
}
function getUser(userId, authdata) {
    try {
        var encodedText = window.atob(authdata);
        var pwd = encodedText.split(':')[1]
        var user = { id: parseInt(userId), pwd: pwd }
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify(user)
        };

        return fetch(`api/User/GetUserById`, requestOptions).then(handleResponse);
    }
    catch (error) {
        var user = { id: 0, pwd: "" }
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify(user)
        };
        return fetch(`api/User/GetUserById`, requestOptions).then(handleResponse);
    }
    //return axios({
    //    method: 'GET',
    //    url: 'User/GetUserById',
    //    headers: authHeader(),
    //    body: JSON.stringify({ id: userId, pwd: pwd })
    //    //headers: {
    //    //    'Content-Type': 'application/json'
    //    //}
    //})
    //    .catch(function (error) {
    //        console.log(error);
    //    })
    //    .then(user => {
    //        console.log("101")
    //    });
}
function handleResponse(response) {
    return response.text().then(text => {
        //console.log(response, response.ok);
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

function Test_Refer(whname, refer_by, first_name, last_name, email_id, mobile_no) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ whname, refer_by, first_name, last_name, email_id, mobile_no })
    };
    return fetch(`api/ds/disrefer`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
                if (user) {
                }
                else {
                    var userObj = {};
                }
            }
            catch (error) {
                var userObj = {};
            }
            return user;
        });
}


function Check_Null_Empty(val) {
    if (val == '' || val == null || val == undefined || val == "null" || val == "{}")
        return true;
    else
        return false;
}

function ValidateEmail(val) {
    if (val.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
        return true;
    else
        return false;
}
function validatePhoneNumber(val) {
    var phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return phoneNumberPattern.test(val);
}
function validateCurrency(amount) {
    var regex = /^[0-9]\d*(?:\.\d{0,6})?$/;
    return regex.test(amount);
}
// new email validation 
function ValidateEmailPlus(val) {
    if (val.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
        return true;
    else
        return false;
}

// space validation
function ValidateSpace(string) {
    let firstChar = string.charAt(0);
    let lastChar = string.charAt(string.length - 1);
    if (firstChar == ' ' || lastChar == ' ')
        return true;
    else
        return false;
}

// add dollar 
function AddDollar(val, unitsign) {
    if (val == '') {
        return '';
    } else {
        if (unitsign == '$') {
            let removeDollar = val.replace('$', '');
            let addDecimal = parseFloat(removeDollar).toFixed(2);
            return '$' + addDecimal;
        } else if (unitsign == '%') {
            let removeDollar = val.replace('%', '');
            let addDecimal = parseFloat(removeDollar).toFixed(2);
            return addDecimal + '%';
        } else {
            let removeDollar = val.replace('$', '');
            return '$' + parseFloat(removeDollar).toFixed(2);
        }
    }
}

// payment rail integration
function PaymentRails(Wh_Id, Wh_Email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Wh_Id, Wh_Email })
    };
    return fetch(`api/ws/WhWidgetLink`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}
function validateNumber(elementValue) {
    var phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return phoneNumberPattern.test(elementValue);
}
function loginrxh(quid) {
    try {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ quid })
        };
        return fetch(`api/user/Authenticate_RXH`, requestOptions)
            .then(handleResponse)
            .then(user => {
                try {
                    if (user) {
                        var userObj = {};
                        userObj.userrole = user[0].role;
                        userObj.id = user[0].userId;
                        userObj.email = user[0].userEmail;
                        userObj.username = user[0].userName;
                        userObj.wholesaler = user[0].wholesaler;
                        userObj.wholesaler_Id = user[0].wholesaler_Id;
                        userObj.distributor_UserId = user[0].distributor_UserId;
                        userObj.authdata = window.btoa(user[0].userEmail + ':' + user[0].logg_Set);
                        userObj.paramsname = user[0].paramsName;
                        userObj.dList = user[0].dList;
                        userObj.isfu = user[0].isFu;
                        userObj.isBrokerTypeUser = user[0].isBrokerTypeUser;
                        userObj.r_rgh_i_e_b = window.btoa(user[0].isEnableBroker);
                        userObj.isLegacyUser = user[0].isLegacyUser;
                        userObj.overrideCount = user[0].overrideCount;
                        localStorage.setItem('user', JSON.stringify(userObj));
                        localStorage.setItem('x_resu_t_p', user[0].isFu);
                    }
                    else {
                        var userObj = {};
                        localStorage.setItem('user', JSON.stringify(userObj));
                    }
                }
                catch (error) {
                    var userObj = {};
                    localStorage.setItem('user', JSON.stringify(userObj));
                }
                return user;
            });
    }
    catch (error) { }
}

function GetWh_Analytic(whid, whname) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ whid, whname })
    };
    return fetch(`api/analytic/widget`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}

function GetWh_Termination(whid, whname) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ whid, whname })
    };
    return fetch(`api/admin/Terminated_WhList`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}
function Accept_Comp_Popup(WhId, DistId, UserType, TaskType) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ WhId, DistId, UserType, TaskType })
    };
    return fetch(`api/ws/Accept_Comp_Popup`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}
function Check_LoggedIn_Status() {
    let ReturnURL = "";
    if (localStorage.getItem('user') != null && localStorage.getItem('user') != "" && localStorage.getItem('user') != "null" && localStorage.getItem('user') != "{}") {
        ReturnURL = "";
    }
    else {
        logout();
        ReturnURL = "Login"
    }
    return ReturnURL;
}
function Get_User_Type() {
    let UserType = "N/A";
    try {
        if (localStorage.getItem('user') != null && localStorage.getItem('user') != "" && localStorage.getItem('user') != "null" && localStorage.getItem('user') != "{}") {
            var localstoragedata = JSON.parse(localStorage.getItem('user'));
            UserType = localstoragedata.userrole;
        }
    }
    catch (error) { }
    return UserType;
}
function GetAdvanceSetting(roleName, roleType, id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ roleName, roleType, id })
    };
    return fetch(`api/admin/GetWhAdvanceSetting`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}
function UpdatedAdvanceSetting(whId, listId, listName, isBroker, isWhCC, isPricingEndpoint, isDataEndpoint, isEnrollEndpoint, isBrokerEndpoint, isBrokerWelcomeEmail, isAddBrokerHS, isBrokerCredEmail, isAddBrokerKlaviyo, isPharmacyEndpoint, isPassesEndpoint) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ whId, listId, listName, isBroker, isWhCC, isPricingEndpoint, isDataEndpoint, isEnrollEndpoint, isBrokerEndpoint, isBrokerWelcomeEmail, isAddBrokerHS, isBrokerCredEmail, isAddBrokerKlaviyo, isPharmacyEndpoint, isPassesEndpoint })
    };
    return fetch(`api/admin/ProcessWhAdvanceSetting`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}
function BrokerSignatureSetting(groupNumber, partnerName, partnerPhone, companyName, addressLine1, addressLine2) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ groupNumber, partnerName, partnerPhone, companyName, addressLine1, addressLine2 })
    };
    return fetch(`api/ws/BrokerSignature`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}
function BindAnalyticsFilteredTag(role, Distributor_UserId, name, wholesalerid, datefrom, dateto, FilterJson) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'requestHeader': FilterJson, 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ role, Distributor_UserId, name, wholesalerid, datefrom, dateto })
    };
    return fetch(`api/Analytic/getFilterMatchingTag_Analytic`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}
function Export_reps_bytransaction(Urole, Uemail, start_date, end_date, FilterJson, wid_title) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'requestHeader': FilterJson, 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Urole, Uemail, start_date, end_date, wid_title })
    };
    return fetch(`api/Analytic/Export_reps`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {

            }
            return user;
        });
}

function BonusProgram(whId, monthName, whBonus, userBonus, BIN) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ whId, monthName, whBonus, userBonus, BIN })
    };
    return fetch(`api/ws/Bonus_Program`, requestOptions).then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}

function Wh_GlicAPI(Wh_Id, Wh_Email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Wh_Id, Wh_Email })
    };
    return fetch(`api/ws/Wh_Glic_API`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function Bind_Tier_List(WholesalerId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ WholesalerId })
    };
    return fetch(`api/admin/userMilestonestuff`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function Wh_Bonus_Setting(roleName, roleType, id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ roleName, roleType, id })
    };
    return fetch(`api/admin/GetWhBonusSetting`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function Admin_Any_Search(stext) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ stext })
    };
    return fetch(`api/admin/iSearch`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function checkNumericValue(val) {
    var numericePattern = /^[\+\-]?\d*\.?\d+(?:[Ee][\+\-]?\d+)?$/;
    return numericePattern.test(val);
}
function TierProperties(userType, userId, whId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ userType, userId, whId })
    };
    return fetch(`api/User/Get_UserTierProperties`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function UpdateFinanceUser(fusername, fuseremail, whid, isfu, issupport, istechnical) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ fusername, fuseremail, whid, isfu, issupport, istechnical })
    };
    return fetch(`/api/admin/Set_Update_FinanceUser`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function GetDashboardList(roleName, roleType, id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ roleName, roleType, id })
    };
    return fetch(`/api/admin/GetDashboardList`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function AddWhDashUser(roleName, roleType, whName, whId, userName, userEmail) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ roleName, roleType, whName, whId, userName, userEmail })
    };
    return fetch(`/api/admin/AddWhDashUser`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function SaveNotification(Not_Heading, Not_Content, UserFor, PublichedUserEmail, PublichedUserType, PublishedOn) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Not_Heading, Not_Content, UserFor, PublichedUserEmail, PublichedUserType, PublishedOn })
    };
    return fetch(`/api/Account/CreateNotification`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function GetNotification(UserType, UserEmail, FilterJson) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ UserType, UserEmail, FilterJson })
    };
    return fetch(`/api/Account/GetNotification`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function GetUserNotification(roleName, roleType, id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ roleName, roleType, id })
    };
    return fetch(`/api/Account/GetUserNotification`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function NotificationAcknowledge(id, roleType, roleName) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ id, roleType, roleName })
    };
    return fetch(`/api/Account/Notification_Acknowledge`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function SearchEmailCampaignType(emailid, campaignType, WhName) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ emailid, campaignType, WhName })
    };
    return fetch(`/api/ws/SearchOnTypeText_CampaignType`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function ProcessUserCampaign(UserJson, WhName, GroupNumber, MaxComm) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ UserJson, WhName, GroupNumber, MaxComm })
    };
    return fetch(`/api/ws/ProcessUser_CampaignUser`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function NotificationClosing(Not_Id, UserType, UserEmail, FilterJson) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Not_Id, UserType, UserEmail, FilterJson })
    };
    return fetch(`/api/Account/Notification_Close`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function CompnayOverViewSearch(UserName, Stext) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ UserName, Stext })
    };
    return fetch(`/api/ComOverview/co_top_search`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function WhPrescribeInfo(quid) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ quid, quid })
    };
    return fetch(`/api/ws/PrescribeInfo`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function GetWhiteListedIP(ObjectUid, EmailId, IP) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ ObjectUid, EmailId, IP })
    };
    return fetch(`/api/ws/WhiteListIPs`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function ProcessWhiteListIP(ObjectUid, EmailId, IP, stype) {
    const ipType = stype ? 'Dynamic IP' : 'Static IP'
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ ObjectUid, EmailId, IP, sType: ipType })
    };
    return fetch(`/api/ws/ProcessWhiteListIPs`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function ResetWhiteListIP(ObjectUid, EmailId, IP, stype) {
    const ipType = stype ? 'Dynamic IP' : 'Static IP'
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ ObjectUid, EmailId, IP, sType: ipType })
    };
    return fetch(`/api/ws/Reset_WhiteListIPs`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function fetchPharmacyChainList(id, name) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ id, name })
    };
    return fetch(`/api/admin/PharmacyChainList`, requestOptions)
}
function fetchUserPharmacyChainList(Wholesaler_Name, Wholesaler_Id, flag) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Wholesaler_Name, Wholesaler_Id, flag })
    };
    return fetch(`/api/admin/UserPharmacyChainList`, requestOptions)
}
function wh_ChainCommission(whname, wholesaler_Id, mname) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ whname, wholesaler_Id, mname })
    };
    return fetch(`/api/ws/wh_ChainCommission_Type`, requestOptions)
        .then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        });
}
function updatePharmacyChainList(PharmacyChainJson, Wholesaler_Name, Wholesaler_Id, flag) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', PharmacyChainJson: JSON.stringify(PharmacyChainJson), 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Wholesaler_Name, Wholesaler_Id, flag })
    };
    return fetch(`/api/admin/PharmacyChainSetting`, requestOptions).then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        })
}
function add_update_PharmacyChainList_gs(PharmacyChainJson, Wholesaler_Name, Wholesaler_Id, flag, GroupNumber, GroupSpecific) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', PharmacyChainJson: JSON.stringify(PharmacyChainJson), 'X-Browser-Url': window.location.href },
        body: JSON.stringify({ Wholesaler_Name, Wholesaler_Id, flag, GroupNumber, GroupSpecific })
    };
    return fetch(`/api/admin/PharmacyChainSetting_gs`, requestOptions).then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        })
}
function generatebearerToken(ClientId, ClientSecret, Base64Value) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href, 'Authorization': Base64Value },
        body: JSON.stringify({ ClientId, ClientSecret})
    };
    return fetch(`/api/ws/GenerateToken`, requestOptions).then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        })
}
function regeneratebearerToken(ClientId, ClientSecret, Base64Value) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href, 'Authorization': Base64Value },
        body: JSON.stringify({ ClientId, ClientSecret })
    };
    return fetch(`/api/ws/RegenerateToken`, requestOptions).then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        })
}
function listTokens(ClientId, Base64Value) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href, 'Authorization': Base64Value },
        body: JSON.stringify({ ClientId })
    };
    return fetch(`/api/ws/ListTokens`, requestOptions).then(handleResponse)
        .then(user => {
            try {
            }
            catch (error) {
            }
            return user;
        })
}